import React from 'react';
import { Card, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Building, Fingerprint, Calendar4Range, GeoAlt, HouseGear } from 'react-bootstrap-icons';

const BranchInfo = () => {
    const { userData } = useSelector((state) => state.auth);
    const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch")) || {};
    const defaultBranch = userData?.employee?.branch_default || {};

    const branchDetails = [
        { label: 'Branch Name', value: selectedBranch.branch_name || selectedBranch.label, icon: <Building size={12} />, id: 'branch_name' },
        { label: 'Nphies ID', value: selectedBranch.branch_nphies_code, icon: <Fingerprint size={12} />, id: 'nphies_id' },
        { label: 'CCHI Number', value: selectedBranch.branch_cchino || selectedBranch.branch_cchi, icon: <Calendar4Range size={12} />, id: 'cchi' },
        { label: 'City / Location', value: selectedBranch.city || 'Saudi Arabia', icon: <GeoAlt size={12} />, id: 'location' },
    ];

    return (
        <Card className="border-0 shadow-sm rounded-3">
            <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-2">
                        <div className="bg-primary-subtle p-2 rounded-2 d-flex align-items-center justify-content-center">
                            <HouseGear className="text-primary" size={18} />
                        </div>
                        <h6 className="fw-bold mb-0 text-primary fs-10">Branch Information</h6>
                    </div>
                    {selectedBranch.branch_id === defaultBranch.branch_id && (
                        <span className="badge bg-success-subtle text-success border border-success px-2 py-1 rounded-pill fs-11 fw-medium">
                            Current Default
                        </span>
                    )}
                </div>

                <Form>
                    <Row className="g-3">
                        {branchDetails.map((item, index) => (
                            <Col md={6} key={index}>
                                <Form.Group>
                                    <Form.Label className="text-700 fw-medium fs-11 mb-1">{item.label}</Form.Label>
                                    <InputGroup className=" rounded-3 overflow-hidden border-0" style={{ border: '1px solid #edf2f9 !important' }}>
                                        <InputGroup.Text className="bg-transparent border-0 pe-0 text-500">
                                            {item.icon}
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            defaultValue={item.value}
                                            readOnly
                                            className="bg-transparent border-0 py-2 fs-10 shadow-none text-600"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        ))}
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default BranchInfo;
